function getDefault() {
  return { title: '', description: '', options: [] };
}

function buildInitialData(formData) {
  if (formData.data === undefined || formData.data === null) {
    return {};
  }
  return JSON.parse(formData.data);
}

function buildInitialForm(formData) {
  if (formData.form === undefined || formData.form === null) {
    return null;
  }
  return JSON.parse(formData.form);
}

function buildInitialOriginalData(formData) {
  if (formData.originalData === undefined || formData.originalData === null) {
    return {};
  }
  return JSON.parse(formData.originalData);
}

function convertObjectToString(value) {
  if (value === undefined || value === null) {
    return null;
  }

  return JSON.stringify(value);
}

function make(formData) {
  if (formData === undefined) {
    return getDefault();
  }

  const data = buildInitialData(formData);
  const originalData = buildInitialOriginalData(formData);
  const form = buildInitialForm(formData);

  return {
    ...getDefault(),
    ...formData,
    data,
    originalData,
    form,
  };
}

function destruct(jForm) {
  const data = convertObjectToString(jForm.data);
  const form = convertObjectToString(jForm.form);
  return { ...jForm, data, form };
}

const FormFactory = {
  make,
  destruct,
};

export default FormFactory;
